import type { Badge } from "@/components/flowbite/badge/badge";
import { dictionaries } from "@/dictionaries/content";
import { ProjectReviewStatusEnum } from "@/providers/store/api/projects/projects.interface";

import type { VariantProps } from "class-variance-authority";

interface ProjectReviewStatusBadge {
  label: string;
  variant: VariantProps<typeof Badge>["variant"];
}

export function getProjectReviewStatusBadge(
  reviewStatus: string | undefined,
): ProjectReviewStatusBadge {
  const copy = dictionaries.newHousingWorkspacePage.detail;

  switch (reviewStatus) {
    case ProjectReviewStatusEnum.PUBLISHED:
      return { label: copy.reviewStatusPublished, variant: "green" };
    case ProjectReviewStatusEnum.READY_FOR_REVIEW:
      return { label: copy.reviewStatusReady, variant: "yellow" };
    case ProjectReviewStatusEnum.DRAFT:
      return { label: copy.reviewStatusNeedInfo, variant: "red" };
    case ProjectReviewStatusEnum.REJECTED:
      return { label: copy.reviewStatusRejected, variant: "red" };
    default:
      return { label: "--", variant: "default" };
  }
}
